import { Button, Popup, PopupArrow, RangeInputGroup } from '@cian/components';
import { Outside } from '@cian/ui-kit';
import * as React from 'react';
import map from 'lodash/map';

import { onInsideClick } from './helpers';
import { OptionalDropdown } from './optional_dropdown';
import { filterChange, filterClick } from './tracking';

const s = require('../search_filters.css');

interface IProps {
  valueFrom?: number;
  valueTo?: number;
  metric: string;
  options: {
    value: string;
    label: string;
  }[];
  onChangeFrom(value: number | undefined): void;
  onChangeTo(value: number | undefined): void;
  onChangeMetric(value: string): void;
}

interface IState {
  opened: boolean;
}

export class SquareFilter extends React.Component<IProps, IState> {
  private input: RangeInputGroup;
  private minSquare: number | undefined;
  private maxSquare: number | undefined;

  public constructor(props: IProps) {
    super(props);

    this.state = { opened: false };
    this.minSquare = props.valueFrom;
    this.maxSquare = props.valueTo;
  }
  // eslint-disable-next-line react/no-deprecated
  public componentWillMount() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionKeys = map(this.props.options, (option: any) => option.value);

    if (optionKeys.indexOf(this.props.metric) === -1) {
      this.props.onChangeMetric(optionKeys[0]);
    }
  }

  public render() {
    return (
      <div className={s['c-filters-field']} onClick={onInsideClick(() => filterClick('ObjectsArea'))}>
        <Outside onOutside={() => this.close()}>
          <div
            className={`${s['c-several-filters-field']}
                        ${this.props.options.length > 1 ? '' : s['c-several-filters-field_disabled']}`}
          >
            <div
              className={`${s['c-filters-field-square']}
                              ${s['c-several-filters-dropdown-container']}`}
            >
              <Button
                buttonStyle={`${s['c-filters-dropdown-button']} ${this.hasSquare() ? '' : s['c-filters-field-mute']}`}
                onClick={() => {
                  this.togglePopup(() => this.focus(true));
                }}
              >
                {this.formatCaption() || 'Площадь'}
              </Button>
              {this.renderPopup()}
            </div>
            <OptionalDropdown
              onChange={(value: string) => this.props.onChangeMetric(value)}
              onClick={() => {
                this.togglePopup(() => this.focus(false));
              }}
              values={this.props.options}
              value={this.props.metric}
            />
          </div>
        </Outside>
      </div>
    );
  }

  private focus(first: boolean) {
    if (this.input) {
      if (first) {
        this.input.focusMinField();
      } else {
        this.input.focusMaxField();
      }
    }
  }

  private togglePopup(callback: () => void, opened: boolean = !this.state.opened) {
    this.setState({ opened }, callback);
  }

  private close() {
    this.togglePopup(() => null, false);
  }

  private renderPopup() {
    if (this.state.opened) {
      return (
        <Popup arrow={PopupArrow.LEFT} containerStyle={`${s['c-filters-dropdown']}`}>
          <div>
            <RangeInputGroup
              ref={(input: RangeInputGroup) => {
                this.input = input;
              }}
              rangeGroupStyle={`${s['c-filters-dropdown-content']}
                              ${s['c-filters-area-content']}`}
              min={{
                inputStyle: `${s['c-filters-area-input']} ${s['c-filters-text-input']}`,
                onBlur: () => {
                  const nextMinSquare = this.props.valueFrom ? Math.abs(this.props.valueFrom) : undefined;
                  if (this.minSquare !== nextMinSquare) {
                    filterChange(
                      'ObjectsAreaMin',
                      typeof this.props.valueFrom !== 'undefined' ? String(Math.abs(this.props.valueFrom)) : 'deleted',
                    );

                    this.minSquare = nextMinSquare;
                  }
                },
                onValueChange: value => this.props.onChangeFrom(value ? Math.abs(value) : undefined),
                placeholder: 'от',
                value: this.props.valueFrom,
              }}
              max={{
                inputStyle: `${s['c-filters-area-input']} ${s['c-filters-text-input']}`,
                onBlur: () => {
                  let { valueTo } = this.props;
                  valueTo = valueTo ? Math.max(this.props.valueFrom || 0, Math.abs(valueTo)) : undefined;

                  this.props.onChangeTo(valueTo);

                  if (this.maxSquare !== valueTo) {
                    filterChange('ObjectsAreaMax', valueTo ? String(valueTo) : 'deleted');

                    this.maxSquare = valueTo;
                  }
                },
                onValueChange: value => this.props.onChangeTo(value || undefined),
                placeholder: 'до',
                value: this.props.valueTo,
              }}
            />
          </div>
        </Popup>
      );
    } else {
      return <div></div>;
    }
  }

  private hasSquare() {
    return this.props.valueFrom && this.props.valueFrom > 0;
  }

  private formatCaption() {
    const { valueFrom, valueTo } = this.props;

    if (valueFrom && valueTo) {
      return `${valueFrom} - ${Math.max(valueFrom, valueTo)}`;
    } else if (valueFrom) {
      return `от ${valueFrom}`;
    } else if (valueTo) {
      return `до ${valueTo}`;
    } else {
      return null;
    }
  }
}
